import PieChartWidget from './PieChartWidget';
import { PieChartMeta, WidgetDefinition } from '../../../shared/types/widget';

interface PieChartProps {
  definition: WidgetDefinition;
  content: PieChartMeta;
}

function PieChart({ definition, content }: PieChartProps) {
  const { id } = definition;

  const chartData = content?.data;
  const numericId = Number.isNaN(Number(id)) ? 0 : Number(id);

  return <PieChartWidget data={chartData} id={numericId} />;
}

export default PieChart;
